<template>
  <div style="padding: 10px">
    <div style="margin: 10px 0">
      <el-input v-model="search.accountName" placeholder="账号名" @keyup.enter.native="load" style="width: 10%"
                clearable></el-input>
      <el-select v-model="search.parentRoleId" clearable filterable placeholder="请选择父账号" style="width: 10%">
        <el-option
            v-for="item in parentIdDict"
            :key="item.parentRoleId"
            :label="item.accountName"
            :value="item.parentRoleId">
        </el-option>
      </el-select>
      <el-button type="primary" style="margin-left: 5px" @click="load">查询</el-button>
      <el-button style="margin-left: 5px" @click="resetData">重置</el-button>
      <!-- 动态字段配置按钮 -->
      <el-button type="warning" style="margin-left: 5px" @click="openDynamicFieldsConfig">动态字段配置</el-button>
    </div>

    <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%">
      <el-table-column
          prop="accountName"
          label="账号名">
      </el-table-column>
      <el-table-column prop="roleId" label="角色ID">
        <template #default="{row}">
        <span
            class="copyable-text"
            @click="copyToClipboard(row.roleId)"
        >
          {{ row.roleId }}
          <i class="el-icon-document-copy"></i>
        </span>
        </template>
      </el-table-column>
      <!-- 下次上号时间 -->
      <el-table-column
          label="下次收菜时间">
        <template #default="{row}">
          <span v-if="row.loginStatus === 0" style="color: #909399">不上号</span>
          <span v-else-if="!row.claimRewardStatus" style="color: #e6a23c">限时不收菜</span>
          <span v-else>{{ row.nextLoginTime }}</span>
        </template>
      </el-table-column>
      <!-- 下次发车时间 -->
      <el-table-column
          label="下次发车时间">
        <template #default="{row}">
          <span v-if="row.loginStatus === 0" style="color: #909399">不上号</span>
          <span v-else-if="!parseCarSetting(row.carSetting)?.send" style="color: #e6a23c">不发车</span>
          <span v-else-if="parseCarSetting(row.carSetting)?.nextSendCar">
            {{ formatTimestamp(parseCarSetting(row.carSetting)?.nextSendCar) }}
          </span>
          <span v-else>无发车时间</span>
        </template>
      </el-table-column>
      <!-- 下次收车时间 -->
      <el-table-column
          label="下次收车时间">
        <template #default="{row}">
          <span v-if="row.loginStatus === 0" style="color: #909399">不上号</span>
          <span v-else-if="!row.carClaim" style="color: #e6a23c">不收车</span>
          <span v-else>{{ row.nextCarClaimTime }}</span>
        </template>
      </el-table-column>
      <!-- 下次爬塔时间 -->
      <el-table-column
          label="下次爬塔时间">
        <template #default="{row}">
          <span v-if="row.loginStatus === 0" style="color: #909399">不上号</span>
          <span v-else-if="!row.towerStatus" style="color: #e6a23c">不爬塔</span>
          <span v-else>{{ row.nextTowerTime }}</span>
        </template>
      </el-table-column>
      <!-- 下次怪异塔时间 -->
      <el-table-column
          label="下次怪异塔时间">
        <template #default="{row}">
          <span v-if="row.loginStatus === 0" style="color: #909399">不上号</span>
          <span v-else-if="!row.evotowerStatus" style="color: #e6a23c">不打怪异塔</span>
          <span v-else>{{ row.nextEvotowerTime }}</span>
        </template>
      </el-table-column>

      <!-- 是否上号 - Switch开关 -->
      <el-table-column
          label="是否上号">
        <template #default="{row}">
          <el-switch
              v-model="row.loginStatus"
              :active-value="1"
              :inactive-value="0"
              active-text="是"
              inactive-text="否"
              @change="handleStatusChange('loginStatus', row)">
          </el-switch>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="80px" v-if="this.userId === 1">
        <template #default="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <!--新增编辑表单-->
    <el-dialog title="新增/编辑" v-model="dialogVisible" width="30%">
      <el-form :model="form">
        <el-form-item label="账号名">
          <el-input v-model="form.accountName"></el-input>
        </el-form-item>
        <el-form-item label="是否上号">
          <el-select v-model="form.loginStatus" placeholder="请选择是否上号" clearable>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否日常">
          <el-select v-model="form.dailyTaskStatus" placeholder="请选择是否日常" clearable>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>

        <!-- 添加其他状态控制 -->
        <el-form-item label="是否收菜">
          <el-select v-model="form.claimRewardStatus" placeholder="请选择是否收菜" clearable>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否收车">
          <el-select v-model="form.carClaim" placeholder="请选择是否收车" clearable>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否爬塔">
          <el-select v-model="form.towerStatus" placeholder="请选择是否爬塔" clearable>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否怪异塔">
          <el-select v-model="form.evotowerStatus" placeholder="请选择是否怪异塔" clearable>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="save">确 定</el-button>
          </span>
      </template>
    </el-dialog>

    <!-- 动态字段配置弹窗 -->
    <el-dialog title="动态字段配置" v-model="dynamicFieldsDialogVisible" width="60%" :close-on-click-modal="false">
      <div class="dynamic-fields-header">
        <el-button type="primary" size="small" @click="addDynamicField">新增字段组</el-button>
        <el-button type="danger" size="small" @click="clearDynamicFields" style="margin-left: 10px;">清空动态字段</el-button>
        <el-tag type="info" size="small" style="margin-left: 20px;">点击"新增字段组"添加配置，可添加多个</el-tag>
      </div>

      <el-collapse v-model="activeCollapseItems" accordion>
        <el-collapse-item
            v-for="(dynamicSetting, index) in dynamicFields"
            :key="index"
            :name="index"
            :title="`字段组 ${index + 1}: ${dynamicSetting.fieldName || '未命名'}`"
        >
          <el-form :model="dynamicSetting" label-width="100px" style="margin-top: 20px;">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="字段名称" prop="fieldName">
                  <el-input v-model="dynamicSetting.fieldName" placeholder="如: isActivity" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-button type="danger" size="small" @click="removeDynamicField(index)" style="float: right;">删除此组</el-button>
              </el-col>
            </el-row>

            <el-divider></el-divider>

            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="label" prop="label">
                  <el-input v-model="dynamicSetting.label" placeholder="如: 是否开启" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="value" prop="value">
                  <el-input v-model="dynamicSetting.value" placeholder="如: true, 3, 2" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="disabled" prop="disabled">
                  <el-select v-model="dynamicSetting.disabled" placeholder="是否禁用" clearable style="width: 100%">
                    <el-option label="是" :value="true"></el-option>
                    <el-option label="否" :value="false"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="desc" prop="desc">
              <el-input
                  v-model="dynamicSetting.desc"
                  type="textarea"
                  :rows="2"
                  placeholder="如: 太史慈四圣活动自动打怪（6个boss那个，周五14点打，后面8点打）"
                  clearable
              ></el-input>
            </el-form-item>
          </el-form>
        </el-collapse-item>
      </el-collapse>

      <div class="json-preview">
        <div class="json-preview-title">预览 JSON:</div>
        <pre class="json-preview-content">{{ previewDynamicFields }}</pre>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dynamicFieldsDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveDynamicFields">保 存</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'accountInfo',
  components: {},
  data() {
    return {
      dialogVisible: false,
      // 动态字段配置相关
      dynamicFieldsDialogVisible: false,
      dynamicFields: [],
      activeCollapseItems: [],

      parentIdDict: [],
      form: {
        createTime: '',
        loginStatus: '',
        dailyTaskStatus: '',
        claimRewardStatus: '',
        dungeon: '',
        carClaim: '',
        arenaStatus: '',
        towerStatus: '',
        evotowerStatus: ''
      },
      clubForm: {
        type: '',
        ids: [],
        clubCode: ''
      },
      tenKingForm: {
        type: '',
        ids: []
      },
      userId: '',
      loading: true,
      search: {},
      query: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      // 防抖定时器
      debounceTimer: null
    }
  },
  computed: {
    // 预览动态字段的JSON格式
    previewDynamicFields() {
      if (this.dynamicFields.length === 0) {
        return '{}';
      }

      const result = {};
      this.dynamicFields.forEach(dynamicSetting => {
        if (dynamicSetting.fieldName) {
          // 自动判断value的类型
          let value = dynamicSetting.value;

          // 尝试转换为数字
          if (!isNaN(value) && value !== '') {
            if (value.includes('.')) {
              value = parseFloat(value);
            } else {
              value = parseInt(value, 10);
            }
          }
          // 尝试转换为布尔
          else if (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') {
            value = value.toLowerCase() === 'true';
          }

          result[dynamicSetting.fieldName] = {
            label: dynamicSetting.label || '',
            desc: dynamicSetting.desc || '',
            value: value,
            disabled: dynamicSetting.disabled === true
          };
        }
      });

      return JSON.stringify(result, null, 2);
    }
  },
  created() {
    this.load()
    let userStr = sessionStorage.getItem("user") || "{}"
    let user = JSON.parse(userStr)
    this.userId = user.id;
  },
  mounted() {
    this.getParentIdList();
  },
  methods: {
    // 打开动态字段配置弹窗
    openDynamicFieldsConfig() {
      // 初始示例数据
      this.dynamicFields = [
        {
          fieldName: 'team',
          label: '阵容编号',
          desc: '填写阵容编号，1-6的数字，不要乱写其他内容',
          value: '2',
          disabled: false
        }
      ];
      this.activeCollapseItems = [0];
      this.dynamicFieldsDialogVisible = true;
    },

    // 新增字段组
    addDynamicField() {
      this.dynamicFields.push({
        fieldName: '',
        label: '',
        desc: '',
        value: '',
        disabled: false
      });
      // 展开最后一个
      this.activeCollapseItems = [this.dynamicFields.length - 1];
    },

    // 删除字段组
    removeDynamicField(index) {
      this.dynamicFields.splice(index, 1);
      if (this.dynamicFields.length > 0) {
        this.activeCollapseItems = [Math.max(0, index - 1)];
      } else {
        this.activeCollapseItems = [];
      }
    },

    // 清空动态字段
    clearDynamicFields() {
      this.$confirm('确定要清空所有动态字段吗？这将删除所有配置。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        request.post("/accountInfoWs/updateNoticeBatch", {
          dynamicSetting: null
        }).then(res => {
          this.loading = false;
          if (res.code === '0') {
            this.$message({
              type: "success",
              message: "清空成功"
            });
            this.dynamicFields = [];
            this.dynamicFieldsDialogVisible = false;
          } else {
            this.$message({
              type: "error",
              message: res.msg || "清空失败"
            });
          }
        }).catch(error => {
          this.loading = false;
          this.$message.error("网络错误，清空失败");
        });
      }).catch(() => {
        // 用户取消
      });
    },

    // 保存动态字段
    saveDynamicFields() {
      // 过滤掉没有fieldName的项
      const validFields = this.dynamicFields.filter(dynamicSetting => dynamicSetting.fieldName.trim() !== '');

      if (validFields.length === 0) {
        this.$message.warning("请至少填写一个有效的字段配置");
        return;
      }

      // 构建JSON对象
      const jsonData = {};
      validFields.forEach(dynamicSetting => {
        if (dynamicSetting.fieldName) {
          // 自动判断value的类型
          let value = dynamicSetting.value;

          // 尝试转换为数字
          if (!isNaN(value) && value !== '') {
            if (value.includes('.')) {
              value = parseFloat(value);
            } else {
              value = parseInt(value, 10);
            }
          }
          // 尝试转换为布尔
          else if (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') {
            value = value.toLowerCase() === 'true';
          }

          jsonData[dynamicSetting.fieldName] = {
            label: dynamicSetting.label || '',
            desc: dynamicSetting.desc || '',
            value: value,
            disabled: dynamicSetting.disabled === true
          };
        }
      });

      // 转换为JSON字符串
      const jsonString = JSON.stringify(jsonData);
      this.loading = true;
      request.post("/accountInfoWs/updateNoticeBatch", {
        dynamicSetting: jsonString
      }).then(res => {
        this.loading = false;
        if (res.code === '0') {
          this.$message({
            type: "success",
            message: "保存成功"
          });
          this.dynamicFieldsDialogVisible = false;
        } else {
          this.$message({
            type: "error",
            message: res.msg || "保存失败"
          });
        }
      }).catch(error => {
        this.loading = false;
        this.$message.error("网络错误，保存失败");
      });
    },

    // 解析carSetting JSON
    parseCarSetting(carSettingStr) {
      try {
        if (!carSettingStr) return null;
        return JSON.parse(carSettingStr);
      } catch (error) {
        console.error('解析carSetting失败:', error);
        return null;
      }
    },

    // 时间戳转日期
    formatTimestamp(timestamp) {
      if (!timestamp) return '无';
      const date = new Date(timestamp * 1000);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).replace(/\//g, '-');
    },

    // Switch开关改变事件
    handleStatusChange(field, row) {
      // 防抖处理，避免频繁调用接口
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      this.debounceTimer = setTimeout(() => {
        this.updateStatus(field, row);
      }, 300);
    },

    // 更新状态到后端
    updateStatus(field, row) {
      this.loading = true;

      // 构建更新数据
      const updateData = {
        id: row.id,
        [field]: row[field]
      };

      request.post("/accountInfoWs/update", updateData).then(res => {
        this.loading = false;
        if (res.code === '0') {
          this.$message({
            type: "success",
            message: "更新成功"
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg || "更新失败"
          });
          this.load();
        }
      }).catch(error => {
        this.loading = false;
        this.$message({
          type: "error",
          message: "网络错误，更新失败"
        });
        this.load();
      });
    },

    async copyToClipboard(text) {
      const textToCopy = text.toString()

      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(textToCopy)
          this.$message.success('复制成功')
          return
        } catch (err) {
          console.warn('现代Clipboard API失败，使用降级方案')
        }
      }

      const textArea = document.createElement('textarea')
      textArea.value = textToCopy
      textArea.style.position = 'fixed'
      textArea.style.opacity = '0'

      document.body.appendChild(textArea)
      textArea.select()

      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.$message.success('复制成功')
        } else {
          this.$message.error('复制失败')
        }
      } catch (err) {
        this.$message.error('复制失败')
      } finally {
        document.body.removeChild(textArea)
      }
    },

    add() {
      this.dialogVisible = true
      this.form = {}
    },

    handleEdit(row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true
    },

    save() {
      this.loading = true;
      if (this.form.id) {
        request.post("/accountInfoWs/update", this.form).then(res => {
          if (res.code === '0') {
            this.$message({
              type: "success",
              message: res.msg
            })
          } else {
            this.$message({
              type: "error",
              message: res.msg
            })
          }
          this.load()
          this.loading = false
          this.dialogVisible = false
        })
      }
    },

    resetData() {
      this.search = {}
      this.load()
    },

    getParentIdList() {
      request.get("/accountInfo/parentList", {}).then(res => {
        this.loading = false
        this.parentIdDict = res.data
      })
    },

    load() {
      this.loading = true
      const searchForm = {...this.search}
      let obj = Object.assign(searchForm, this.query)
      let reqData = {
        ...obj
      }
      reqData.current = this.currentPage
      reqData.size = this.pageSize
      request.get("/accountInfoWs/list", {
        params: reqData
      }).then(res => {
        this.loading = false
        this.tableData = res.data.records
        this.total = res.data.total

        // 确保数据格式正确
        this.tableData.forEach(row => {
          // 如果字段是字符串形式的布尔值，转换为布尔类型
          if (typeof row.claimRewardStatus === 'string') {
            row.claimRewardStatus = row.claimRewardStatus === 'true';
          }
          if (typeof row.carClaim === 'string') {
            row.carClaim = row.carClaim === 'true';
          }
          if (typeof row.towerStatus === 'string') {
            row.towerStatus = row.towerStatus === 'true';
          }
          if (typeof row.evotowerStatus === 'string') {
            row.evotowerStatus = row.evotowerStatus === 'true';
          }
        })
      })
    },

    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.load()
    },

    handleCurrentChange(pageNum) {
      this.currentPage = pageNum
      this.load()
    },
  }
}
</script>

<style scoped>
  /* 可选：为Switch添加一些样式 */
.el-switch {
  margin: 2px 0;
}

/* 复制文本样式 */
.copyable-text {
  cursor: pointer;
  color: #409EFF;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.copyable-text:hover {
  text-decoration: underline;
}
/* ===== 修复对话框暗色主题 ===== */
body.dark-theme .el-dialog {
  background-color: #1d1d1d !important;
  border: 1px solid #434343 !important;
  color: #e5eaf3 !important;
}

body.dark-theme .el-dialog__header {
  background-color: #1d1d1d !important;
  border-bottom: 1px solid #434343 !important;
  padding: 20px 20px 10px;
  color: #e5eaf3 !important;
}

body.dark-theme .el-dialog__title {
  color: #e5eaf3 !important;
  font-weight: 600;
  font-size: 16px;
}

body.dark-theme .el-dialog__body {
  background-color: #1d1d1d !important;
  color: #e5eaf3 !important;
  padding: 20px !important;
}

/* ===== 修复折叠面板暗色主题 ===== */
body.dark-theme .el-collapse {
  background-color: #000000 !important; /* 黑色背景 */
  border: 1px solid #434343 !important;
  border-radius: 4px;
}

/* 根据图片：标题栏是白色背景，黄色文字 */
body.dark-theme .el-collapse-item__header {
  background-color: #1d1d1d !important; /* 深色背景 */
  color: #f5dd06 !important; /* 黄色字体 */
  border-bottom: 1px solid #1d1d1d !important; /* 浅灰色边框 */
  padding: 0 20px;
  height: 48px;
  line-height: 48px;
  font-weight: 600;
  font-size: 16px;
  position: relative;
}

/* 根据图片：箭头图标是黑色 */
body.dark-theme .el-collapse-item__arrow {
  color: #000000 !important; /* 黑色箭头 */
  font-size: 16px;
  font-weight: bold;
  margin-right: 10px;
}

body.dark-theme .el-collapse-item__header:hover {
  background-color: #1d1d1d !important; /* 悬停时稍深的白色 */
  color: #f5dd06 !important;
}

/* 激活状态的折叠面板标题栏 */
body.dark-theme .el-collapse-item.is-active .el-collapse-item__header {
  background-color: #1d1d1d !important;
  color: #f5dd06 !important;
  border-bottom: 1px solid #ddd !important;
}

  body.dark-theme .el-collapse-item__header.is-active {
    background: #141414 !important;
  }


/* 内容区域 - 图片中是黑色背景 */
body.dark-theme .el-collapse-item__wrap {
  background-color: #000000 !important; /* 纯黑色背景 */
  border-bottom: 1px solid #434343 !important;
}

body.dark-theme .el-collapse-item__content {
  background-color: #000000 !important; /* 纯黑色背景 */
  color: #f5dd06 !important; /* 黄色文字 */
  padding: 20px;
  font-size: 13px;
  line-height: 1.8;
  border-top: 2px solid #333 !important;
}

/* ===== 修复动态字段配置弹窗内部样式 ===== */
/* 按钮区域 */
body.dark-theme .dynamic-fields-header {
  background-color: #141414 !important;
  padding: 15px 20px;
  border-radius: 6px;
  margin-bottom: 20px;
  border: 1px solid #434343;
}

/* 行和列 */
body.dark-theme .el-row {
  margin-bottom: 20px;
}

body.dark-theme .el-col {
  padding: 0 10px;
}

/* 分割线 */
body.dark-theme .el-divider {
  background-color: #333 !important;
  margin: 15px 0;
  height: 1px;
}

body.dark-theme .el-divider__text {
  background: #1d1d1d !important;
  color: #a8abb2 !important;
  padding: 0 20px;
  font-weight: 500;
  font-size: 13px;
}

/* JSON预览区域 */
body.dark-theme .json-preview {
  background: #141414 !important;
  border: 1px solid #434343 !important;
  border-radius: 4px;
  padding: 20px;
  margin-top: 20px;
}

body.dark-theme .json-preview-title {
  color: #a8abb2 !important;
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 14px;
}

body.dark-theme .json-preview-content {
  background: #0a0a0a !important;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #333;
  max-height: 200px;
  overflow: auto;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.5;
  color: #4ec9b0 !important;
  white-space: pre-wrap;
  word-break: break-all;
}

/* 对话框底部 */
body.dark-theme .el-dialog__footer {
  background-color: #1d1d1d !important;
  border-top: 1px solid #434343 !important;
  padding: 20px;
  text-align: right;
}

/* 删除按钮样式 */
body.dark-theme .el-button--danger[small] {
  background: #2c0d0d !important;
  border-color: #5d1a1a !important;
  color: #f56c6c !important;
  height: 28px;
  padding: 0 12px;
  font-size: 12px;
}

body.dark-theme .el-button--danger[small]:hover {
  background: #f56c6c !important;
  border-color: #f56c6c !important;
  color: white !important;
}

/* 输入框在对话框中的样式 */
body.dark-theme .el-dialog .el-input__inner,
body.dark-theme .el-dialog .el-textarea__inner {
  background-color: #0a0a0a !important;
  border: 1px solid #434343 !important;
  color: #ffffff !important; /* 白色文字 */
  border-radius: 4px;
  height: 36px;
  line-height: 36px;
  padding: 0 15px;
}

body.dark-theme .el-dialog .el-textarea__inner {
  background-color: #0a0a0a !important;
  min-height: 60px;
  line-height: 1.5;
  padding: 5px 15px;
  border: 1px solid #434343 !important;
  color: #f5dd06 !important; /* 黄色文字 */
}

body.dark-theme .el-dialog .el-input__inner::placeholder,
body.dark-theme .el-dialog .el-textarea__inner::placeholder {
  color: #f5dd06 !important; /* 黄色占位符 */
  opacity: 0.8;
}

/* 输入框聚焦效果 */
body.dark-theme .el-dialog .el-input__inner:focus,
body.dark-theme .el-dialog .el-textarea__inner:focus {
  border-color: #f5dd06 !important; /* 黄色边框 */
  outline: none;
  box-shadow: 0 0 0 2px rgba(245, 221, 6, 0.2);
}

/* 下拉选择框在对话框中的样式 */
body.dark-theme .el-dialog .el-select {
  width: 100%;
}

/* 表单在折叠面板中的样式 */
body.dark-theme .el-collapse-item__content .el-form-item {
  margin-bottom: 20px;
}

/* 删除按钮在折叠面板中的位置 */
body.dark-theme .el-collapse-item__content .el-button--danger[small] {
  background: transparent !important; /* 无背景 */
  border-color: #f5dd06 !important; /* 黄色边框 */
  color: #f5dd06 !important; /* 黄色文字 */
  height: 28px;
  padding: 0 12px;
  font-size: 12px;
  border-radius: 4px;
  float: right;
  margin-top: 5px;
}

body.dark-theme .el-collapse-item__content .el-button--danger[small]:hover {
  background: #f5dd06 !important; /* 悬停时黄色背景 */
  border-color: #f5dd06 !important;
  color: #000000 !important; /* 悬停时黑色文字 */
}

/* 滚动条样式 */
body.dark-theme .json-preview-content::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

body.dark-theme .json-preview-content::-webkit-scrollbar-track {
  background: #0a0a0a;
  border-radius: 4px;
}

body.dark-theme .json-preview-content::-webkit-scrollbar-thumb {
  background: #434343;
  border-radius: 4px;
}

body.dark-theme .json-preview-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* 响应式调整 */
@media (max-width: 768px) {
  body.dark-theme .el-col {
    width: 100% !important;
    margin-bottom: 15px;
  }

  body.dark-theme .el-dialog {
    width: 90% !important;
  }
}

/* ===== 表单在折叠面板内的特殊样式 ===== */
/* 第一行：字段名称和删除按钮 */
body.dark-theme .el-collapse-item__content .el-row:first-child {
  margin-bottom: 20px;
  border-bottom: 1px solid #333 !important;
  padding-bottom: 15px;
}

/* 表单标签在折叠面板内 - 图片中是黄色标签 */
body.dark-theme .el-collapse-item__content .el-form-item__label {
  background-color: #000000 !important; /* 黑色背景 */
  color: #f5dd06 !important; /* 黄色文字 */
  font-weight: 500;
  padding-right: 20px;
  min-width: 80px;
  text-align: right;
  font-size: 13px;
}

/* 表单在折叠面板内 */
body.dark-theme .el-collapse-item__content .el-form {
  background-color: #000000 !important; /* 黑色背景 */
  padding: 0;
  margin: 0;
}

/* 行和列在折叠面板内 */
body.dark-theme .el-collapse-item__content .el-row {
  background-color: #000000 !important; /* 黑色背景 */
  margin-bottom: 20px;
}

body.dark-theme .el-collapse-item__content .el-col {
  background-color: #000000 !important; /* 黑色背景 */
  padding: 0 10px;
}

/* 输入框在折叠面板内 */
body.dark-theme .el-collapse-item__content .el-input__inner,
body.dark-theme .el-collapse-item__content .el-textarea__inner {
  background-color: #0a0a0a !important; /* 深黑色背景 */
  border: 1px solid #434343 !important;
  color: #ffffff !important; /* 白色文字 */
  border-radius: 4px;
  height: 36px;
  line-height: 36px;
  padding: 0 15px;
  width: 100%;
  font-size: 13px;
}

/* 描述信息的文本域内文字是黄色的 */
body.dark-theme .el-collapse-item__content .el-textarea__inner {
  color: #f5dd06 !important; /* 黄色文字 */
  background-color: #0a0a0a !important;
  min-height: 60px;
  line-height: 1.5;
  padding: 5px 15px;
  border: 1px solid #434343 !important;
  font-size: 13px;
  resize: vertical;
}

/* 占位符文本 */
body.dark-theme .el-collapse-item__content .el-input__inner::placeholder,
body.dark-theme .el-collapse-item__content .el-textarea__inner::placeholder {
  color: #f5dd06 !important; /* 黄色占位符 */
  opacity: 0.8;
}

/* 下拉选择框在折叠面板内 */
body.dark-theme .el-collapse-item__content .el-select .el-input__inner {
  background-color: #0a0a0a !important;
  border: 1px solid #434343 !important;
  color: #ffffff !important; /* 白色文字 */
}

/* 下拉框选项 */
body.dark-theme .el-collapse-item__content .el-select-dropdown__item {
  background-color: #0a0a0a !important;
  color: #ffffff !important;
}

/* 下拉框选中的选项 */
body.dark-theme .el-collapse-item__content .el-select-dropdown__item.selected {
  background-color: #f5dd06 !important; /* 黄色背景 */
  color: #000000 !important; /* 黑色文字 */
}

/* 分割线在折叠面板内 */
body.dark-theme .el-collapse-item__content .el-divider {
  background-color: #333 !important;
  margin: 20px 0;
  height: 1px;
}

/* 表单项在折叠面板内 */
body.dark-theme .el-collapse-item__content .el-form-item {
  background-color: #000000 !important; /* 黑色背景 */
  margin-bottom: 20px;
  border: none;
}

/* 确保所有折叠面板内容区域的元素都有黑色背景 */
body.dark-theme .el-collapse-item__content *:not(.el-input__inner):not(.el-textarea__inner):not(.el-select .el-input__inner) {
  background-color: #000000 !important;
  color: #f5dd06 !important;
}

/* 特殊处理输入框的背景色 */
body.dark-theme .el-collapse-item__content .el-input__inner,
body.dark-theme .el-collapse-item__content .el-textarea__inner,
body.dark-theme .el-collapse-item__content .el-select .el-input__inner {
  background-color: #0a0a0a !important;
  color: #ffffff !important;
}
</style>
